var map = {
	"./abb-color.svg": 1768,
	"./afb-color.svg": 1769,
	"./afb.svg": 1770,
	"./agro-color.svg": 1771,
	"./alb-color.svg": 1772,
	"./alb.svg": 1773,
	"./amb-color.svg": 1774,
	"./amb.svg": 1775,
	"./bbbaidja-color.svg": 1776,
	"./bbbaidjaxxx-color.svg": 1777,
	"./bdinidjaxxx-color.svg": 1778,
	"./bimb-color.svg": 1779,
	"./bimb.svg": 1780,
	"./bkr-color.svg": 1781,
	"./bkr.svg": 1782,
	"./bmriidja-color.svg": 1783,
	"./bniaidja-color.svg": 1784,
	"./bninidja-color.svg": 1785,
	"./bninidjaxxx-color.svg": 1786,
	"./boc-color.svg": 1787,
	"./bpay-color.svg": 1788,
	"./brinidja002-color.svg": 1789,
	"./bsmdidjaxxx-color.svg": 1790,
	"./bsn-color.svg": 1791,
	"./bsn.svg": 1792,
	"./btanidjaxxx-color.svg": 1793,
	"./cenaidja-color.svg": 1794,
	"./cenaidjaxxx-color.svg": 1795,
	"./cimb-color.svg": 1796,
	"./cimb.svg": 1797,
	"./citi-color.svg": 1798,
	"./citi.svg": 1799,
	"./default-bank-icon-color.png": 1800,
	"./default-bank-icon.png": 1801,
	"./gxbank-color.svg": 1802,
	"./hlb-color.svg": 1803,
	"./hlb.svg": 1804,
	"./hsbc-color.svg": 1805,
	"./hsbc.svg": 1806,
	"./ibbkidjaxxx-color.svg": 1807,
	"./kfh-color.svg": 1808,
	"./kwh-color.svg": 1809,
	"./kwh.svg": 1810,
	"./mbb-color.svg": 1811,
	"./mbb.svg": 1812,
	"./muamalat-color.svg": 1813,
	"./nispidjaxxx-color.svg": 1814,
	"./ocbc-color.svg": 1815,
	"./ocbc.svg": 1816,
	"./pbb-color.svg": 1817,
	"./pbb.svg": 1818,
	"./pinbidja-color.svg": 1819,
	"./raykat-color.svg": 1820,
	"./rhb-b.svg": 1821,
	"./rhb-color-b.svg": 1822,
	"./rhb-color.svg": 1823,
	"./rhb.svg": 1824,
	"./scb-color.svg": 1825,
	"./scb.svg": 1826,
	"./tng-color.svg": 1827,
	"./uob-color.svg": 1828,
	"./uob.svg": 1829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;